import { DaysBySelections, ScheduleTaskConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getScheduleTaskTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as ScheduleTaskConfig;

	return [
		{
			id: 'schedule-enabled',
			selector: '[data-tour="schedule-enabled"]',
			content:
				'Used to enable or disable the schedule. When the schedule is disabled it will not trigger any flow.',
		},
		{
			id: 'schedule-minute-type',
			selector: '[data-tour="schedule-minute-type"]',
			content:
				'Used to set whether the schedule should run every X number of minutes or at a specific minute.',
		},
		{
			id: 'schedule-selected-minute',
			selector: '[data-tour="schedule-selected-minute"]',
			content: 'Used to define the minute value when configuring the schedule.',
		},
		{
			id: 'schedule-hour-type',
			selector: '[data-tour="schedule-hour-type"]',
			content:
				'Used to set whether the schedule should run every X number of hours or at a specific hour.',
		},
		{
			id: 'schedule-selected-hour',
			selector: '[data-tour="schedule-selected-hour"]',
			content: 'Used to define the hour value when configuring the schedule.',
		},
		{
			id: 'schedule-day-mode',
			selector: '[data-tour="schedule-day-mode"]',
			content:
				'Used to determine whether the schedule runs based on specific days of the week or days of the month.',
		},
		...(config.cronProps.daysBy === DaysBySelections.Month
			? [
					{
						id: 'schedule-day-type',
						selector: '[data-tour="schedule-day-type"]',
						content:
							'Used to set whether the schedule runs every X number of days of the month or on a specific day of the month. Only visible when "Day(s) of month" is selected.',
					},
				]
			: []),

		{
			id: 'schedule-day-selection',
			selector: '[data-tour="schedule-day-selection"]',
			content: 'Used to select the specific day(s) of the month when the schedule should run.',
		},
		{
			id: 'schedule-last-day-of-month',
			selector: '[data-tour="schedule-last-day-of-month"]',
			content:
				'Used to specify whether the schedule should only run on the last selected day of the month.',
		},
		{
			id: 'schedule-month',
			selector: '[data-tour="schedule-month"]',
			content:
				'Used to select which month the schedule should run in. If no month is selected, the task will run every month.',
		},
		{
			id: 'expected-schedule',
			selector: '[data-tour="expected-schedule"]',
			content: 'Displays the expected schedule based on the configuration rules selected above.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
